import axios from "axios";

let abortController: AbortController | null = null;

export const internalDirectoryApi = async (value: string) => {
  try {
    // Cancel previous request if it's still pending
    if (abortController) {
      abortController.abort();
    }

    // Create new abort controller for this request
    abortController = new AbortController();
    const signal = abortController.signal;

    const response = await axios.get(
      `${process.env.REACT_APP_INTERNAL_DIRECTORY_BASE_URL}/users?query=(givenName=${value}*)`,
      {
        headers: {
          "x-merck-apikey": process.env.REACT_APP_INTERNAL_DIRECTORY_KEY,
        },
        signal,
      },
    );

    return response.data;
  } catch (err: any) {
    // Handle abort errors silently
    if (axios.isCancel(err)) {
      return null;
    }

    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
